var React = require('react');

function ShareInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_983_84)","key":0},React.createElement("path",{"d":"M10 3V5H5V19H19V14H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H10ZM17.586 5H13V3H21V11H19V6.414L12 13.414L10.586 12L17.586 5Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_983_84"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

ShareInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ShareInline;

ShareInline.default = ShareInline;
